export const stats = [
  { label: "Growth Campaigns", value: 240 },
  { label: "Content Assets", value: 1800 },
  { label: "Client NPS", value: 96 },
  { label: "Avg. ROI", value: 6 }
];